// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__3fQdj","range":"MonthRangeSwitch_range__3ATQa","disabled":"MonthRangeSwitch_disabled__1Ix6F"};